import React, { useState, useEffect } from "react";
import Modal from "../../../components/modal";
import moment from "moment";

const AssetsFormPage = ({ show, onClose, heading, initialData = {}, onSubmit }) => {
    // State to manage form inputs
    const [formData, setFormData] = useState({
        item_name: '',
        amount: '',
        quantity: '',
        comment: '',
        purchase_date: '',
        is_disposal: false,
    });

    // Load initial data into form if editing an existing asset
    useEffect(() => {
        if (initialData) {
            setFormData({
                item_name: initialData.item_name || '',
                amount: initialData.amount || '',
                quantity: initialData.quantity || '',
                comment: initialData.comment || '',
                purchase_date: initialData.purchase_date 
                ? moment(initialData.purchase_date).format("YYYY-MM-DD")  // Ensure correct format
                : '',
                is_disposal: initialData.is_disposal || false,
            });
        }
    }, [initialData]);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <Modal
            show={show}
            onClose={onClose}
            heading={heading}
        >
            <form onSubmit={handleSubmit}>
                <div className="row">
                    {/* Item Name */}
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Item Name</label>
                            <input
                                type="text"
                                name="item_name"
                                className="form-control"
                                value={formData.item_name}
                                onChange={handleChange}
                                placeholder="Enter Item Name"
                                required
                            />
                        </div>
                    </div>

                    {/* Amount */}
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Amount</label>
                            <input
                                type="number"
                                name="amount"
                                className="form-control"
                                value={formData.amount}
                                onChange={handleChange}
                                placeholder="Enter Amount"
                                required
                            />
                        </div>
                    </div>

                    {/* Quantity */}
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Quantity</label>
                            <input
                                type="number"
                                name="quantity"
                                className="form-control"
                                value={formData.quantity}
                                onChange={handleChange}
                                placeholder="Enter Quantity"
                                required
                            />
                        </div>
                    </div>

                    {/* Purchase Date */}
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Purchase Date</label>
                            <input
                                type="date"
                                name="purchase_date"
                                className="form-control"
                                value={formData.purchase_date}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    {/* Comment */}
                    <div className="col-md-12">
                        <div className="form-group mb-4">
                            <label>Comment</label>
                            <textarea
                                name="comment"
                                className="form-control"
                                value={formData.comment}
                                onChange={handleChange}
                                placeholder="Enter comments (optional)"
                            />
                        </div>
                    </div>

                    {/* Is Disposal Checkbox */}
                    <div className="col-md-12">
                        <div className="form-check mb-4">
                            <input
                                type="checkbox"
                                name="is_disposal"
                                className="form-check-input"
                                checked={formData.is_disposal}
                                onChange={handleChange}
                            />
                            <label className="form-check-label ms-2">Is Disposal?</label>
                        </div>
                    </div>
                </div>

                {/* Buttons */}
                <div className="d-flex justify-content-end">
                    <button 
                        type="button" 
                        className="btn btn-light me-2" 
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                        Save
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default AssetsFormPage;
